import axios from 'axios';
const getTimesheet = startDate =>
  axios.get(`/timesheets/get_timesheet?start_date=${startDate}`);
const updateTimesheet = ({ status, timesheetId }) =>
  axios.post(`/timesheets/update_timesheet`, {
    status,
    timesheet_id: timesheetId,
  });
const createWorkHour = ({
  date,
  comment,
  timesheetId,
  companyId,
  primaryHours,
  secondaryHours,
}) =>
  axios.post(`/timesheets/create_work_hour`, {
    date,
    comment,
    timesheet_id: timesheetId,
    company_id: companyId,
    primary_hours: primaryHours,
    secondary_hours: secondaryHours,
  });
const updateWorkHour = ({
  comment,
  workHourId,
  companyId,
  primaryHours,
  secondaryHours,
}) =>
  axios.post(`/timesheets/update_work_hour`, {
    comment,
    work_hour_id: workHourId,
    company_id: companyId,
    primary_hours: primaryHours,
    secondary_hours: secondaryHours,
  });
const deleteWorkHour = work_hour_id =>
  axios.get(`/timesheets/delete_work_hour/?work_hour_id=${work_hour_id}`);
export default {
  getTimesheet,
  updateTimesheet,
  createWorkHour,
  updateWorkHour,
  deleteWorkHour,
};
